import React from "react";

const Textarea = ({
  input: { name, onChange, value },
  meta: { invalid, touched, error, submitError },
  label,
  placeholder,
  required,
  autoComplete,
  style,
  className,
  tabIndex
}) => (
  <div className={`${invalid && touched ? "has-error" : ""}`}>
    {label && <label className="form-label">{label}</label>}
    <textarea
      tabIndex={tabIndex}
      className={className}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete || "off"}
      style={style}
    />
    {invalid && touched && (
      <p className="form-input-hint">{error || submitError}</p>
    )}
  </div>
);

export default Textarea;
